// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/citation',
    name: 'Citation',
    component: layout,
    redirect: '/citation/index',
    meta: {
      title: '信源分析',
      icon: 'i-menu:citation',
      i18Key: 'router.user.citation.title',
      roles: [1]
    },
    sort: 30,
    children: [
      {
        path: 'index',
        name: 'CitationIndex',
        component: () => import('@/views/Citation/Index.vue'),
        meta: {
          title: '信源分析',
          icon: 'i-menu:citation',
          i18Key: 'router.user.citation.index',
          roles: [1],
          headerConditions: ['brand', 'timeBtn', 'questionBtn']
        }
      }
    ]
  }
]
export default routes
